var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "msg-area" },
    [
      _c("msg-block", [
        _c("p", [
          _c("b", [
            _vm._v(
              _vm._s(_vm.translations.welcome_msg_title) +
                " " +
                _vm._s(_vm.agencyName)
            )
          ])
        ]),
        _vm._v(" "),
        _c("p", {
          domProps: { innerHTML: _vm._s(_vm.translations.welcome_msg) }
        })
      ]),
      _vm._v(" "),
      _c("msg-block", { attrs: { type: "warning" } }, [
        _c("p", {
          domProps: { innerHTML: _vm._s(_vm.translations.offer_notice) }
        })
      ]),
      _vm._v(" "),
      _vm.loadingOffer
        ? _c("msg-block", { staticClass: "item-loading" }, [
            _c("p", [
              _c("b", {
                domProps: {
                  textContent: _vm._s(_vm.translations.loading_offer)
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingError
        ? _c("msg-block", { attrs: { type: "error" } }, [
            _c("p", [
              _c("b", { domProps: { textContent: _vm._s(_vm.loadingError) } })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isNKOffer
        ? _c(
            "modal",
            {
              staticClass: "modal-view--bg modal--booking",
              attrs: {
                title: _vm.translations.NK_notice_title,
                isOpen: true,
                noScroll: true
              },
              on: { close: _vm.goBackToSearch }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    slot: "icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 435.2 405.04"
                  },
                  slot: "icon"
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M115.14,0H319.9c63.34,0,115.3,50.72,115.3,112.83v94.09C435.2,269,383.24,320,319.9,320H259.11l-97.75,81.47c-4.23,3.77-19.92,4.6-25.09,2.28A13.83,13.83,0,0,1,128,390.87V320H115.14C51.79,320,0,269,0,206.92V112.83C0,50.72,51.79,0,115.14,0Z"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.translations.NK_notice) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "modal-actions" }, [
                _c("a", {
                  staticClass: "btn",
                  attrs: { href: "javascript:void(0)" },
                  domProps: {
                    textContent: _vm._s(_vm.translations.ERRORS.no_offer_back)
                  },
                  on: { click: _vm.goBackToSearch }
                })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isRQTravel
        ? _c("msg-block", { attrs: { type: "warning" } }, [
            _c("p", [
              _c("b", {
                domProps: { textContent: _vm._s(_vm.translations.RQ_notice) }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.bookingError
        ? _c("msg-block", { attrs: { type: "error" } }, [
            _c("p", [
              _c("b", { domProps: { innerHTML: _vm._s(_vm.bookingError) } })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.bookingState
        ? _c("msg-block", { staticClass: "item-loading" }, [
            _c("p", [
              _c("b", { domProps: { innerHTML: _vm._s(_vm.bookingState) } })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.adminWarning
        ? _c(
            "msg-block",
            { attrs: { type: "warning" } },
            [
              _vm._l(_vm.translations.ERRORS.booking_warning, function(
                txt,
                txtKey
              ) {
                return _c("p", {
                  key: "adminwarning_" + txtKey,
                  domProps: { innerHTML: _vm._s(txt) }
                })
              }),
              _vm._v(" "),
              _c("a", {
                attrs: { href: "/" },
                domProps: {
                  textContent: _vm._s(_vm.translations.back_btn_frontpage)
                }
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showChangesModal
        ? _c(
            "modal",
            {
              staticClass: "modal-view--bg modal--booking",
              attrs: {
                title: _vm.translations.ERRORS.change_notice_title,
                isOpen: true,
                closeOnClick: true
              },
              on: { close: _vm.closeChangesModal }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    slot: "icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 435.2 405.04"
                  },
                  slot: "icon"
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M115.14,0H319.9c63.34,0,115.3,50.72,115.3,112.83v94.09C435.2,269,383.24,320,319.9,320H259.11l-97.75,81.47c-4.23,3.77-19.92,4.6-25.09,2.28A13.83,13.83,0,0,1,128,390.87V320H115.14C51.79,320,0,269,0,206.92V112.83C0,50.72,51.79,0,115.14,0Z"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.changeList.length > 0
                ? _c("div", [
                    _c("p", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.translations.ERRORS.change_notice_txt
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(_vm.filteredChangeList, function(
                        changedTxt,
                        changedKey
                      ) {
                        return _c("li", {
                          key: changedKey,
                          domProps: { innerHTML: _vm._s(changedTxt) }
                        })
                      })
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-actions" }, [
                      _c("button", {
                        staticClass: "btn",
                        domProps: {
                          textContent: _vm._s(
                            _vm.translations.ERRORS.change_notice_btn
                          )
                        },
                        on: { click: _vm.closeChangesModal }
                      })
                    ])
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fc03966", { render: render, staticRenderFns: staticRenderFns })
  }
}